export const ADSLIDER_LIST_ATTEMPT = 'ADSLIDER_LIST_ATTEMPT';
export const ADSLIDER_LIST_SUCCESS = 'ADSLIDER_LIST_SUCCESS';
export const ADSLIDER_LIST_FAILED = 'ADSLIDER_LIST_FAILED';
